// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const UsersEmail = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <circle cx='15' cy='16.1' r='6.4' />
      <path d='M3.6,28.5c0,4.9,4.9,10.9,10.9,10.9s4.1-.8,5.7-1.9c-2.1-2.5-3.3-5.6-3.3-8.4s1.9-2.3,4.6-2.8c-6.2-1.3-17.9-.6-17.9,2.3Z' />
      <circle cx='31.2' cy='13.5' r='8.1' />
      <rect x='27' y='27.2' width='20.5' height='14.8' rx='1.5' ry='1.5' fill='none' />
      <polyline points='47.3 28.4 37.2 35.2 27 28.4' fill='none' />
      <path d='M28.5,42.1c-.9,0-1.5-.7-1.5-1.5v-11.8c0-.9.7-1.5,1.5-1.5h14.5c-1.8-1-5.1-1.7-8.8-1.9-4.4-.3-9.3,0-12.7.8-2.8.6-4.6,1.5-4.6,2.8,0,2.8,1.2,6,3.3,8.4,2.3,2.8,5.5,4.8,9.2,5.2l.5-.5h-1.4Z' />
    </svg>
  );
};
